'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var concat = Array.prototype.concat;

var flatten = exports.flatten = function flatten(array) {
  return concat.apply([], array);
};

var throwInvariant = exports.throwInvariant = function throwInvariant(condition, message) {
  if (!condition) {
    throw Error(message);
  }
};

var mapValues = exports.mapValues = function mapValues(object, mapper) {
  return Object.keys(object).reduce(function (current, key) {
    current[key] = mapper(object[key], key);
    return current;
  }, {});
};

var promisify = exports.promisify = function promisify(nodeStyleFunction) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new Promise(function (resolve, reject) {
      nodeStyleFunction.apply(undefined, args.concat([function (error, result) {
        if (error) reject(error);else resolve(result);
      }]));
    });
  };
};

var isPromiseLike = exports.isPromiseLike = function isPromiseLike(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.then === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-loop/lib/utils.js
// module id = 38
// module chunks = 0